// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__38Ka2","label":"Radio_label__23ZM9","checkMark":"Radio_checkMark__24LzC","disabled":"Radio_disabled__1EYF-"};